<template>
  <div class="pc-search">
    <el-form
      class="pc-search-main-formOne "
      :model="keywordData"
      :inline="true"
    >
      <el-form-item label="前沿名称" class="realName">
        <el-input
          v-model="keywordData.title"
          placeholder="请输入前沿名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="标签" class="topTwo">
        <!-- <el-input v-model="keywordData.tag"></el-input> -->
        <!-- <el-select v-model="keywordData.tag" placeholder="选择标签" class="tag">
          <el-option label="私立" value="0"></el-option>
          <el-option label="211" value="1"></el-option>
          <el-option label="985" value="2"></el-option>
          <el-option label="公立" value="3"></el-option>
        </el-select> -->
        <el-cascader
          :options="options"
          @change="saveTag($event)"
          clearable
        ></el-cascader>
      </el-form-item>

      <el-form-item label="发布时间" class="createTime">
        <el-date-picker
          v-model="keywordData.createTime"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item label="发布者" class="topTwo">
        <!-- <el-input v-model="keywordData.wupenLegend"></el-input> -->
        <el-select
          v-model="keywordData.author"
          clearable
          placeholder="选择发布者"
        >
          <el-option
            v-for="(item, index) in teacherList"
            :key="index"
            :value="item.author ? item.author : item.authorEnglishName"
            :label="item.author ? item.author : item.authorEnglishName"
            :disabled="item.disabled"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <button class="pc-search-clickBtn" @click="search">筛选</button>
  </div>
</template>



<script>
import { getDictionaries, getExplorationAuthor } from "../explorationList.gql";
import { getTagTypes } from "../../../template/graphql/typeTag.gql";
export default {
  data() {
    return {
      keywordData: {
        keywordTag: null,
        keywordTeacher: null,
        realName: null,
        tag: null,
        title: null,
        id: null,
        createTime: [],
        wupenLegend: null,
        awardsName: null,
        keywords: "",
        createTime: null
      },
      // 标签接口
      typeTagArgs: {
        skip: 0,
        type: "Exploration",
        order: "+createTime"
      },
      // 奖项接口后端需要的接口
      practiceAwardsArgs: {
        skip: 0,
        status: -1,
        take: 12,
        total: 0,
        cell: 0
      },
      // 大洲字段
      continentList: [],
      // 国家字段
      countryList: [],
      // 城市字段
      cityList: [],
      // 测试标签字段
      options: [],
      // 授课老师数组
      teacherList: []
    };
  },
  mounted() {
    // // 获取设计师
    this.getTeacherList();
    // // 获取标签
    this.getTagTypes();
  },
  methods: {
    // 渲染标签
    getTagTypes() {
      this.$global
        .GraphqlQuery(this, getTagTypes, this.typeTagArgs)
        .then(res => {
          this.options = [];
          for (let i = 0; res.data.length > i; i++) {
            this.options.push(res.data[i]);
            this.options[i].value = this.options[i].name;
            this.options[i].label = this.options[i].name;
            if (res.data[i].tags.length > 0) {
              this.options[i].children = res.data[i].tags;
              for (let t = 0; res.data[i].children.length > t; t++) {
                this.options[i].children[t].label = this.options[i].children[
                  t
                ].name;
                this.options[i].children[t].value = this.options[i].children[
                  t
                ].name;
              }
            }
          }
        });
    },
    // 获取授课教师
    getTeacherList() {
      this.$global
        .GraphqlQuery(this, getExplorationAuthor, {
          status: 1
        })
        .then(res => {
          this.teacherList = res.data;
        });
    },
    // 保存设计者
    saveTeacher(id) {
      this.keywordData.keywordTeacher = id;
    },
    saveTag(tagData) {
      this.keywordData.keywordTag = tagData[1] ? tagData[1] : null;
    },
    search() {
      let keyword = "";
      keyword = this.keywordData.keywordTeacher
        ? keyword + this.keywordData.keywordTeacher + ","
        : keyword;
      keyword = this.keywordData.keywordTag
        ? keyword + this.keywordData.keywordTag + ","
        : keyword;
      this.keywordData.keywords = keyword.substr(0, keyword.length - 1);
      this.$emit("search", this.keywordData);
    }
  }
};
</script>



<style lang="scss" scoped>
.pc-search {
  position: relative;
  .pc-search-main-formOne {
    margin-bottom: 10px;
    display: flex;
    flex-wrap: wrap;
  }
  /deep/ .el-form-item {
    margin-bottom: 20px !important;
  }
  /deep/ .el-form--inline .el-form-item {
    margin-right: 0 !important;
  }

  // 换三角形
  /deep/ .el-icon-arrow-up:before {
    content: "";
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid $thirdTitle;
    font-size: 0;
    line-height: 0;
  }
  /deep/ .el-input__icon {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  // 预设两行
  /deep/ .el-form-item__label {
    font-family: $chinese;
    font-size: 14px;
    font-weight: bold;
    color: $mainTitle;
    width: 70px;
  }
  /deep/ .el-input__inner {
    margin-right: 40px;
    border: 1px solid $schoolTagBorder;
    height: 40px;
    padding: 0 10px;
  }
  /deep/ .pc-search-main-formTwo .el-input__inner {
    margin-right: 9px;
  }
  /deep/ .el-input__suffix {
    right: 45px;
  }
  /deep/ .pc-search-main-formTwo .el-input__suffix {
    right: 13px;
  }
  // 第一行 名称
  /deep/ .realName {
    width: 42%;
    .el-form-item__content {
      width: 80%;
      .el-input__inner {
        width: 100%;
      }
    }
  }
  // 第一行 标签
  /deep/ .topTwo .el-input__inner {
    width: 240px;
  }

  /deep/ .createTime {
    width: 42%;
    .el-form-item__content {
      width: 80%;

      .el-range-separator {
        line-height: 40px;
      }
    }
  }
  // 第一行 wupen联盟 状态
  /deep/ .wupenLegend .el-input__inner,
  /deep/ .status .el-input__inner {
    width: 120px;
  }
  // 第二行 地域
  /deep/ .continent .el-input__inner,
  /deep/ .country .el-input__inner,
  /deep/ .city .el-input__inner {
    width: 120px;
  }
  .pc-search-main-formTwo {
    margin-top: 19px;
  }

  .pc-search-clickBtn {
    position: absolute;
    right: 0;
    bottom: 25px;
    width: 90px;
    height: 40px;
    background: $blueBtn;
    border-radius: 4px;
    outline: none;
    border: none;
    font-family: $chinese;
    font-size: 14px;
    color: white;
    cursor: pointer;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/exploration/components/ExplorationSearch.vue